// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Change colors in this file to style to your needs on a global level. 
Certain colors are used for different and multiply types of elements. 
For greater control over colors visit each components .scss file. */
.skills-main-div {
  display: flex;
  width: 100%;
  overflow: hidden;
}

.skills-text-div {
  margin-left: 50px;
}

.skills-main-div > * {
  flex: 1 1;
  margin-bottom: 30px;
}

.skills-image-div > img {
  max-width: 100%;
  height: auto;
}

.skills-heading {
  font-size: 56px;
  font-weight: 400;
}

.subTitle {
  color: #868e96;
}

/* Media Query */
@media (max-width: 1380px) {
  .skills-heading {
    font-size: 40px;
  }
}
@media (max-width: 768px) {
  .skills-heading {
    font-size: 30px;
    text-align: center;
  }
  .greeting-text-p {
    font-size: 16px;
    line-height: normal;
  }
  .skills-main-div {
    flex-direction: column;
  }
  .skills-text-div {
    margin-left: 0px;
    margin: 20px;
  }
  .skills-text {
    font-size: 16px;
  }
  .skills-text-subtitle {
    font-size: 16px;
    text-align: center;
  }
  .skills-image-div {
    /* display: none; */
    order: 2;
  }
}`, "",{"version":3,"sources":["webpack://./src/_globalColor.scss","webpack://./src/containers/skills/Skills.scss"],"names":[],"mappings":"AAAA;;mEAAA;ACEA;EACE,aAAA;EACA,WAAA;EACA,gBAAA;AAEF;;AACA;EACE,iBAAA;AAEF;;AACA;EACE,SAAA;EACA,mBAAA;AAEF;;AACA;EACE,eAAA;EACA,YAAA;AAEF;;AACA;EACE,eAAA;EACA,gBAAA;AAEF;;AAAA;EACE,cDfS;ACkBX;;AAAA,gBAAA;AACA;EACE;IACE,eAAA;EAGF;AACF;AADA;EACE;IACE,eAAA;IACA,kBAAA;EAGF;EADA;IACE,eAAA;IACA,mBAAA;EAGF;EADA;IACE,sBAAA;EAGF;EADA;IACE,gBAAA;IACA,YAAA;EAGF;EADA;IACE,eAAA;EAGF;EADA;IACE,eAAA;IACA,kBAAA;EAGF;EADA;IACE,mBAAA;IACA,QAAA;EAGF;AACF","sourcesContent":["/* Change colors in this file to style to your needs on a global level. \nCertain colors are used for different and multiply types of elements. \nFor greater control over colors visit each components .scss file. */\n\n// button colors\n$buttonColor: #55198b;\n$buttonHover: #8c43ce;\n$topButtonHover: #000;\n\n// text colors light theme\n$titleColor: #000000;\n$textColor: #000000;\n$subTitle: #868e96;\n$cardSubtitle: #666666;\n$talkCardSubTitle: #7f8287;\n$blogCardTitleColor: #262626;\n\n// text color dark theme\n$textColorDark: #ffffff;\n\n// toggle switch colors\n$toggleCheck: #2196f3;\n$toggleSwitchSliderBG: #ccc;\n\n// githubRepo specific colors\n$githubRepoCardLanguageColorBG: #0000ff;\n$githubRepoCardColor: rgb(88, 96, 105);\n$githubRepoCardRepoCardStatsColor: rgb(106, 115, 125);\n$githubRepoCardRepoNameColor: rgb(36, 41, 46);\n$githubProfileCardLocationTS: #ffebcd;\n$githubProfileCardBorder: #6c63ff;\n\n// light background colors\n$lightBackground1: #fff;\n$lightBackground2: rgb(255, 255, 255);\n$lightBackground3: #f5f2f4;\n$blogCardContainerColor: #586069;\n// dark background colors\n$darkBackground: #171c28;\n\n// light theme box shadows\n$lightBoxShadowDark: rgba(0, 0, 0, 0.2);\n$lightBoxShadow: rgba(0, 0, 0, 0.1);\n$lightBoxShadowDarker: rgba(0, 0, 0, 0.3);\n\n// dark theme box shadows\n$darkBoxShadow: #d9dbdf;\n$darkBoxShadow2: #ffffff;\n\n// linear gradients\n$experienceCardBlurredDivLG: linear-gradient(\n  rgba(0, 0, 0, 0.4),\n  rgba(0, 0, 0, 0.2)\n);\n$experienceCardBannerLG: linear-gradient(\n  rgba(0, 0, 0, 0.7),\n  rgba(0, 0, 0, 0.5)\n);\n\n// borders\n$progressBarBackground: rgb(243, 239, 239);\n$lightBorder1: rgba(211, 211, 211, 0.397);\n$educationCardBorder: #a9a7f9;\n\n// hovers\n$achievementCertificateCardHoverDark: rgba(255, 255, 255, 0.2);\n$blogCardHoverSmallColor: rgba(255, 255, 255, 0.8);\n$headerHoverBG: #f4f4f4;\n$contactDetailHoverTS: #b5b5b5;\n\n// misc backgrounds\n$progressBarSpanBG: #aaa5ff;\n$iconBackground: #333;\n$appHeaderBG: #282c34;\n\n// misc colors\n$skillsColor: #645beb;\n$appLink: #09d3ac;\n\n// social media icons\n$faceBook: #3b5998;\n$linkedin: #0e76a8;\n$github: #333;\n$gitlab: #fca326;\n$google: #ea4335;\n$twitter: #1da1f2;\n$medium: #000;\n$stackoverflow: #f48024;\n$instagram: #c13584;\n$kaggle: #20beff;\n","@import \"../../_globalColor\";\n\n.skills-main-div {\n  display: flex;\n  width: 100%;\n  overflow: hidden;\n}\n\n.skills-text-div {\n  margin-left: 50px;\n}\n\n.skills-main-div > * {\n  flex: 1;\n  margin-bottom: 30px;\n}\n\n.skills-image-div > img {\n  max-width: 100%;\n  height: auto;\n}\n\n.skills-heading {\n  font-size: 56px;\n  font-weight: 400;\n}\n.subTitle {\n  color: $subTitle;\n}\n\n/* Media Query */\n@media (max-width: 1380px) {\n  .skills-heading {\n    font-size: 40px;\n  }\n}\n@media (max-width: 768px) {\n  .skills-heading {\n    font-size: 30px;\n    text-align: center;\n  }\n  .greeting-text-p {\n    font-size: 16px;\n    line-height: normal;\n  }\n  .skills-main-div {\n    flex-direction: column;\n  }\n  .skills-text-div {\n    margin-left: 0px;\n    margin: 20px;\n  }\n  .skills-text {\n    font-size: 16px;\n  }\n  .skills-text-subtitle {\n    font-size: 16px;\n    text-align: center;\n  }\n  .skills-image-div {\n    /* display: none; */\n    order: 2;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
